<div class="main">
  <div class="col-12 mt-3 py-2 bg-light-color" [class.d-none]="route.children.length !== 0">

    <div class="col-12 d-flex justify-content-end mt-2 pe-3">
      <button nz-button nzType="default" class="me-1" nz-popover nzPopoverContent="Aumentar Zoom"
      nzPopoverPlacement="top" (click)="zoomIn()">
        <span nz-icon nzType="plus-circle" nzTheme="outline"></span>
      </button>
      <button nz-button nzType="default" class="me-1" nz-popover nzPopoverContent="Diminuir Zoom"
      nzPopoverPlacement="top" (click)="zoomOut()">
        <span nz-icon nzType="minus-circle" nzTheme="outline"></span>
      </button>
      <button nz-button nzType="default" class="me-1" nz-popover nzPopoverContent="Resetar Zoom"
      nzPopoverPlacement="top" (click)="resetTransform()">
        <span nz-icon nzType="redo" nzTheme="outline"></span>
      </button>
    </div>
    <div #container class="container" style="position: relative; overflow: hidden; width: 100%; height: 500px;">
      <div #panzoom class="panzoom">
        <app-arvore-hierarquica [item]="hierarchyData" (expandedChange)="onChildExpand($event)"></app-arvore-hierarquica>
      </div>
    </div>
</div>
